import {DELETE_ERROR_SUCCESS} from "../../../reducers/errorsReducer";


export const deleteMessageSuccess = (error) =>{
    return {
        type: DELETE_ERROR_SUCCESS,
        payload: {error}
    }
}